import React, { useEffect } from 'react';
import c from 'classnames';
import styles from './SlideIn.css';

export const SlideIn = ({ isActive, children, changeActiveState }) => {

  const escFunc = ({ keyCode }) => keyCode === 27 ? changeActiveState(false) : null;

  useEffect(() => {
    document.addEventListener('keydown', escFunc);
    return () => document.removeEventListener('keydown', escFunc);
  }, []);

  return (
    <div className={c(styles.slidein, { [styles.active]: isActive })}>
      <div className={c(styles.closeslide, 'closeslide')} onClick={() => { changeActiveState(!isActive); }}></div>
      {children}
    </div>    
  );
};
